import React from 'react';
import commonStyle from '../../assets/common/CommonStyle.module.css';
import s from './AuthCashierPopup.module.css';
import {Field, Form, Formik} from 'formik';
import {CustomInput} from '../Input';
import SelectSvgSelector from '../InputSelect/SelectSvgSelector';
import LightGreenButton from '../Buttons/LightGreenButton';
import {useTranslation} from 'react-i18next';
import {useClickOutside} from '../../hooks/useClickOutside';
import {toast} from 'react-toastify';
import {useAuthCasherMutation} from '../../redux/DepotSlice/depotCashierApi';

interface AuthCashierPopupProps {
	close: (value: boolean) => void;
	supplierId: number;
}

export interface AuthFormValues {
	login: string;
	password: string;
	supplier_id: number;
}
const AuthCashierPopup: React.FC<AuthCashierPopupProps> = ({
	close,
	supplierId,
}) => {
	const {t} = useTranslation();

	const [authCasher] = useAuthCasherMutation();

	const initialValues: AuthFormValues = {
		login: 'test_1gdcbmgoz',
		password: 'test_1gdcbmgoz',
		supplier_id: supplierId,
	};

	const handleSubmit = async (values: AuthFormValues) => {
		try {
			const response = await authCasher(values).unwrap();
			toast.success(response?.message?.textmsg || t('Успішно'));
			close(false);
		} catch (error: any) {
			toast.error(error?.data?.message?.textmsg || t('Помилка авторизації'));
		}
	};
	const handleClosePopup = () => {
		close(true);
	};
	const popupContainerRef = useClickOutside<HTMLDivElement>(handleClosePopup);
	return (
		<div className={commonStyle.popupWrapper}>
			<div
				ref={popupContainerRef}
				className={`${commonStyle.popupContainer} ${s.container}`}
			>
				<div className={s.title}>{t('Авторизація касира')}</div>
				<Formik initialValues={initialValues} onSubmit={handleSubmit}>
					{({values, handleSubmit}) => {
						return (
                            <Form onSubmit={handleSubmit} className={s.form}>
                                <CustomInput
                                    name={'login'}
                                    placeholder={t('Логін')}
                                    icon={<SelectSvgSelector id={'nameIcon'} />}
                                    autoComplete="username"
                                />
                                <CustomInput
                                    name={'password'}
                                    type="password"
                                    placeholder={t('Пароль')}
                                    icon={<SelectSvgSelector id={'password'} />}
                                    autoComplete="current-password"
                                />
								<div className={s.submitButton}>
									<LightGreenButton
										type={'submit'}
										text={t('Авторизувати касира')}
									/>
								</div>
							</Form>
						);
					}}
				</Formik>
			</div>
		</div>
	);
};

export default AuthCashierPopup;
